import React from "react";
import M from "../../../strings";
import { Screen } from "../../components/layout";
import MobileLayout from "../../components/mobile/layout";
import Secure from "../../components/secure";
import * as ui from "../../utils/ui";
import { format, optional } from "../../../utils/lang";
import { ACTION_TYPES } from "../../components/mobile/actions";
import * as _query from "../../../framework/query";
import { connect } from "../../../utils/aj-react";
import { getDefaultState, SurveysStore } from "../../../stores/surveys";
import _ from "underscore";
import { SurveyCard } from "../../components/mobile/surveys";
import { getOpenSurveys } from "../../../actions/surveys";

export default class OngoingSurveys extends Screen {
    constructor(props) {
        super(props);
        const query = _query.create({
            rowsPerPage: 100,
        });
        connect(
                this,
                SurveysStore,
                _.extend(
                        {},
                        getDefaultState(),
                        {
                            query: query,
                        }
                    )
            );

        query.on("change", () => this.getData());
    }

    componentDidMount() {
        this.getData();
    }

    getData() {
        const query = this.state.query;
        getOpenSurveys({
            query: query,
        })
    }

    viewSurvey(surveySummary) {
        ui.navigate("/app/survey/" + surveySummary.survey.id);
    }
    
    render() {
        const rows = optional(() => this.state.openSurveys.rows, []),
            totalRows = optional(() => this.state.openSurveys.totalRows, []),
            title = format(M("ongoingWithNumber"), totalRows),
            leftActions = [
                {
                    id: "back",
                    type: ACTION_TYPES.ICON,
                    icon: "arrow_back",
                    rounded: true,
                    onClick: () => {
                        ui.back();
                        //ui.navigate("")
                    },
                },
            ];

        return(
            <Secure>
                <MobileLayout
                    title={title}
                    leftActions={leftActions}
                >
                    <div
                        className="container-fluid"
                    >
                        <div
                            className="row py-4"
                        >
                            {_.map(rows, row => {
                                return (<div
                                    key={"ongoing-survey-" + row.id}
                                    className="col-sm-12 col-md-6 my-1"
                                >
                                    <SurveyCard
                                        useProgressBar={true}
                                        surveySummary={row}
                                        onClick={this.viewSurvey.bind(this)}
                                    />
                                </div>)
                            })}
                        </div>
                    </div>
                </MobileLayout>
            </Secure>
        )
    }
}